import { render, staticRenderFns } from "./OvertimeRequestCommentList.vue?vue&type=template&id=235c8af0&"
import script from "./OvertimeRequestCommentList.vue?vue&type=script&lang=ts&"
export * from "./OvertimeRequestCommentList.vue?vue&type=script&lang=ts&"
import style0 from "./OvertimeRequestCommentList.vue?vue&type=style&index=0&id=235c8af0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports